import { AppRouteConstants } from '@shared/core';

export const appRouteConstants: AppRouteConstants = {
    login: '/login',
    registration: '/registration',
    error: '/error',
    home: '/main/home',
    main: '/main',
    payment: '/onboarding/payment',
    paymentSuccess: '/onboarding/payment-success',
    paymentMethodSuccess: '/onboarding/payment-method-success',
    settings: '/main/settings',
    telemedicine: '/main/telemedicine',
    telemedicineLobby: '/main/telemedicine/lobby',
    telemedicineCall: '/main/telemedicine/session',
    // telemedicineOndemand: '/main/telemedicine/ondemand',
    // telemedicineOndemandPending: '/main/telemedicine/ondemand/pending',
    insurancePlans: '/onboarding/insurance-plans',
    addPaymentMethod: '/main/profile/payment-method/add',
    profile: '/main/profile',
    support: '/main/support',
    terms: '/public/tac',
    booking: '/main/booking',
    bookingConfirmation: '/main/booking/confirmation',
    bookingDetails: '/main/booking/details',
    bookingList: '/main/booking/list',
};
